import { render, staticRenderFns } from "./SettlementItemsModal.vue?vue&type=template&id=7111babc&"
import script from "./SettlementItemsModal.vue?vue&type=script&lang=js&"
export * from "./SettlementItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports